import { render, staticRenderFns } from "./Domeneshop.vue?vue&type=template&id=4fc065f8"
import script from "./Domeneshop.vue?vue&type=script&lang=js"
export * from "./Domeneshop.vue?vue&type=script&lang=js"
import style0 from "./Domeneshop.vue?vue&type=style&index=0&id=4fc065f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports